// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2NGLV","footer":"ModalFilter_footer__30YMk"};